import { tap } from "./fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { successToast, errorToast } from "./Toasts.jsx";
import { startAsPromise } from "./fable_modules/fable-library-js.4.29.0/Async.js";
import { toastServerError, Notification } from "./ApiClient.jsx";
import { append as append_1, sortByDescending, truncate, map } from "./fable_modules/fable-library-js.4.29.0/Array.js";
import { useCtx, ContextMsg } from "./Context.jsx";
import { toString, Union, Record } from "./fable_modules/fable-library-js.4.29.0/Types.js";
import { union_type, record_type, string_type } from "./fable_modules/fable-library-js.4.29.0/Reflection.js";
import { PopoverSurface, PopoverTrigger, Popover, OverlayDrawer, Link, Spinner, CounterBadge, Tab, TabList, Subtitle2, Button, Tooltip, Body1, Body1Strong, Caption1, Caption2, Caption2Strong, Avatar, tokens } from "@fluentui/react-components";
import { AlertFilled, bundleIcon, AlertBadgeRegular, AlertBadgeFilled, ArrowRightRegular, DismissRegular, CheckmarkRegular, ArrowDownRegular, AlertRegular, BookOpenRegular, PersonClockRegular, PersonAddRegular, CheckmarkCircleRegular } from "@fluentui/react-icons";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { totalDays } from "./fable_modules/fable-library-js.4.29.0/TimeSpan.js";
import { compare, utcNow, op_Subtraction } from "./fable_modules/fable-library-js.4.29.0/Date.js";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Notification as Notification_1 } from "./Shared/SharedModels.jsx";
import { take, length, collect, map as map_1, tryHead, empty, singleton, append, delay, toList, iterate } from "./fable_modules/fable-library-js.4.29.0/Seq.js";
import { RouterModule_encodeParts, RouterModule_nav } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { ofArray } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { defaultArg, toArray } from "./fable_modules/fable-library-js.4.29.0/Option.js";
import { int32ToString, compare as compare_1, safeHash, equals, createObj } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { join } from "./fable_modules/fable-library-js.4.29.0/String.js";
import { formatTimeDiff } from "./Helpers.jsx";
import { defaultOf } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { tryFind, ofArray as ofArray_1 } from "./fable_modules/fable-library-js.4.29.0/Map.js";
import { Array_groupBy } from "./fable_modules/fable-library-js.4.29.0/Seq2.js";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "./fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { BundleIcons } from "./fable_modules/FS.FluentUI.3.0.0/Utils.fs.js";

function fetchNotificationsWithOffset(offset, callback, setIsFetching, setCtx) {
    const pr = tap((res) => {
        try {
            if (res.tag === 1) {
                errorToast(setCtx, "fetchNotificationError", "Kunne ikke hente kunngjøringer", "", undefined);
            }
            else {
                callback(res.fields[0]);
            }
        }
        finally {
            setIsFetching(false);
        }
    }, startAsPromise(Notification.GetMy(offset)));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function updateNotification(notification, ctx, setCtx) {
    const pr = tap((res) => {
        if (res.tag === 1) {
            switch (res.fields[0].tag) {
                case 1: {
                    errorToast(setCtx, "updateNotificationErrorAlreadyOpened", "Kunne ikke oppdatere", "Varslingen du prøver å oppdatere er allerede markert som \'åpnet\'", undefined);
                    break;
                }
                case 2: {
                    errorToast(setCtx, "updateNotificationErrorAlreadyClosed", "Kunne ikke oppdatere", "Varslingen du prøver å oppdatere er allerede markert som \'lest\'", undefined);
                    break;
                }
                default:
                    errorToast(setCtx, "updateNotificationErrorNotfound", "Kunne ikke oppdatere", "Fant ikke varslingen du prøver å oppdatere", undefined);
            }
        }
        else {
            const resNotification = res.fields[0];
            setCtx(new ContextMsg(5, [map((n) => {
                if (n.Id === resNotification.Id) {
                    return resNotification;
                }
                else {
                    return n;
                }
            }, ctx.Notifications)]));
        }
    }, startAsPromise(Notification.Update(notification)));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function updateAllNotification(setCtx) {
    const pr = tap((res) => {
        if (res.tag === 1) {
            errorToast(setCtx, "updateNotificationErrorNotfound", "Kunne ikke oppdatere", "Fant ikke varslingen du prøver å oppdatere", undefined);
        }
        else {
            setCtx(new ContextMsg(5, [[]]));
            successToast(setCtx, "markAllNotificationsSucces", "Varslinger oppdatert", "");
        }
    }, startAsPromise(Notification.MarkAllAsRead()));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

class NotificationKindStyle extends Record {
    constructor(AvatarColor, LabelColor, Label) {
        super();
        this.AvatarColor = AvatarColor;
        this.LabelColor = LabelColor;
        this.Label = Label;
    }
}

function NotificationKindStyle_$reflection() {
    return record_type("Notification.NotificationKindStyle", [], NotificationKindStyle, () => [["AvatarColor", string_type], ["LabelColor", string_type], ["Label", string_type]]);
}

function kindStyle(case$) {
    switch (case$.tag) {
        case 1:
            return new NotificationKindStyle(["color", "brand"], tokens.colorBrandForeground1, "Bruker godkjent");
        case 2:
            return new NotificationKindStyle(["color", "forest"], tokens.colorPaletteForestForeground2, "Plass bekreftet");
        case 3:
            return new NotificationKindStyle(["color", "royal"], tokens.colorPaletteRoyalBlueForeground2, "Venteliste");
        case 4:
            return new NotificationKindStyle(["color", "gold"], tokens.colorPaletteGoldForeground2, "Kurs ferdigstilt");
        case 6:
            return new NotificationKindStyle(["color", "marigold"], tokens.colorPaletteMarigoldForeground1, "Varsel");
        case 5:
            return new NotificationKindStyle(["color", "peach"], tokens.colorPaletteDarkOrangeForeground1, "Nivå nedgradert");
        default:
            return new NotificationKindStyle(["color", "forest"], tokens.colorPaletteForestForeground2, "Ny bruker");
    }
}

function kindIcon(case$) {
    switch (case$.tag) {
        case 1: {
            const el_2 = CheckmarkCircleRegular;
            return createElement(el_2, {
                fontSize: 20,
            });
        }
        case 2: {
            const el_4 = PersonAddRegular;
            return createElement(el_4, {
                fontSize: 20,
            });
        }
        case 3: {
            const el_6 = PersonClockRegular;
            return createElement(el_6, {
                fontSize: 20,
            });
        }
        case 4: {
            const el_8 = BookOpenRegular;
            return createElement(el_8, {
                fontSize: 20,
            });
        }
        case 6: {
            const el_10 = AlertRegular;
            return createElement(el_10, {
                fontSize: 20,
            });
        }
        case 5: {
            const el_12 = ArrowDownRegular;
            return createElement(el_12, {
                fontSize: 20,
            });
        }
        default: {
            const el = PersonAddRegular;
            return createElement(el, {
                fontSize: 20,
            });
        }
    }
}

function targetForNotification(n) {
    const matchValue = n.NotificationType;
    const matchValue_1 = n.ObjectId;
    let matchResult;
    switch (matchValue.tag) {
        case 0: {
            matchResult = 0;
            break;
        }
        case 1: {
            if (matchValue_1 != null) {
                matchResult = 1;
            }
            else {
                matchResult = 5;
            }
            break;
        }
        case 2: {
            if (matchValue_1 != null) {
                matchResult = 2;
            }
            else {
                matchResult = 5;
            }
            break;
        }
        case 6: {
            if (matchValue_1 != null) {
                matchResult = 3;
            }
            else {
                matchResult = 5;
            }
            break;
        }
        case 5: {
            if (matchValue_1 != null) {
                matchResult = 4;
            }
            else {
                matchResult = 5;
            }
            break;
        }
        default:
            matchResult = 5;
    }
    switch (matchResult) {
        case 0:
            return ["admin", "bruker", "godkjenn"];
        case 1:
            return ["bruker", `${matchValue_1}`];
        case 2:
            return ["arrangement", `${matchValue_1}`];
        case 3:
            return ["laeringslop", `${matchValue_1}`];
        case 4:
            return ["laeringslop", `${matchValue_1}`];
        default:
            return undefined;
    }
}

class TimeBucket extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Today", "Yesterday", "ThisWeek", "Earlier"];
    }
}

function TimeBucket_$reflection() {
    return union_type("Notification.TimeBucket", [], TimeBucket, () => [[], [], [], []]);
}

function bucketLabel(_arg) {
    switch (_arg.tag) {
        case 1:
            return "I går";
        case 2:
            return "Denne uken";
        case 3:
            return "Tidligere";
        default:
            return "I dag";
    }
}

function bucketOf(now, inserted) {
    const days = totalDays(op_Subtraction(now, inserted));
    if (days < 1) {
        return new TimeBucket(0, []);
    }
    else if (days < 2) {
        return new TimeBucket(1, []);
    }
    else if (days < 7) {
        return new TimeBucket(2, []);
    }
    else {
        return new TimeBucket(3, []);
    }
}

const bucketOrder = [new TimeBucket(0, []), new TimeBucket(1, []), new TimeBucket(2, []), new TimeBucket(3, [])];

function NotificationRow(notification) {
    let elems_5;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    const patternInput_1 = reactApi.useState(false);
    const setHover = patternInput_1[1];
    const hover = patternInput_1[0];
    const kind = kindStyle(notification.NotificationType);
    const unread = !notification.Opened;
    const handleClick = () => {
        if (unread) {
            updateNotification(new Notification_1(notification.Id, notification.NotificationType, notification.Title, notification.Message, notification.Inserted, notification.ObjectId, true), ctx, setCtx);
        }
        iterate((fullPath) => {
            RouterModule_nav(ofArray(fullPath), 1, 1);
        }, toArray(targetForNotification(notification)));
    };
    return createElement("div", createObj(ofArray([["role", join(" ", ["button"])], ["tabIndex", 0], ["onClick", (_arg) => {
        handleClick();
    }], ["onKeyDown", (ev) => {
        if ((ev.key === "Enter") ? true : (ev.key === " ")) {
            ev.preventDefault();
            handleClick();
        }
    }], ["onMouseEnter", (_arg_1) => {
        setHover(true);
    }], ["onMouseLeave", (_arg_2) => {
        setHover(false);
    }], ["style", createObj(toList(delay(() => append(singleton(["position", "relative"]), delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["alignItems", "flex-start"]), delay(() => append(singleton(["gap", 12 + "px "]), delay(() => append(singleton(["padding", ((((((12 + "px ") + 14) + "px ") + 12) + "px ") + 22) + "px"]), delay(() => append(singleton(["cursor", "pointer"]), delay(() => append(singleton(["borderRadius", 6]), delay(() => append(singleton(["transitionProperty", "background-color"]), delay(() => append(singleton(["transitionDuration", 120 + "ms"]), delay(() => (hover ? singleton(["backgroundColor", tokens.colorNeutralBackground1Hover]) : empty()))))))))))))))))))))))], (elems_5 = toList(delay(() => append(unread ? singleton(createElement("span", {
        "aria-hidden": true,
        style: {
            position: "absolute",
            left: 8,
            top: 50 + "%",
            transform: join(" ", [("translateY(" + (-50 + "%")) + ")"]),
            width: 7,
            height: 7,
            borderRadius: 4,
            backgroundColor: tokens.colorBrandBackground,
            boxShadow: `0 0 0 2px ${tokens.colorNeutralBackground1}`,
        },
    })) : empty(), delay(() => {
        let el;
        return append(singleton((el = Avatar, createElement(el, createObj(ofArray([["shape", "circular"], ["size", 36], kind.AvatarColor, ["icon", kindIcon(notification.NotificationType)]]))))), delay(() => {
            let elems_2, elems, el_2, el_4, el_6, elems_1;
            return append(singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                minWidth: 0,
                gap: 2 + "px ",
            }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
                gap: 6 + "px ",
            }], (elems = [(el_2 = Caption2Strong, createElement(el_2, {
                style: {
                    color: kind.LabelColor,
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                },
                children: kind.Label,
            })), (el_4 = Caption2, createElement(el_4, {
                style: {
                    color: tokens.colorNeutralForeground4,
                },
                children: "·",
            })), (el_6 = Caption1, createElement(el_6, {
                style: {
                    color: tokens.colorNeutralForeground3,
                    whiteSpace: "nowrap",
                },
                children: formatTimeDiff(op_Subtraction(utcNow(), notification.Inserted)),
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
                display: "block",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: "2",
                WebkitBoxOrient: "vertical",
                lineHeight: 1.4,
                color: tokens.colorNeutralForeground1,
            }], (elems_1 = toList(delay(() => {
                let el_8, el_10;
                return append(unread ? singleton((el_8 = Body1Strong, createElement(el_8, {
                    children: notification.Title,
                }))) : singleton((el_10 = Body1, createElement(el_10, {
                    children: notification.Title,
                }))), delay(() => {
                    let el_12;
                    return singleton((el_12 = Body1, createElement(el_12, {
                        style: {
                            color: tokens.colorNeutralForeground2,
                            marginLeft: 4,
                        },
                        children: notification.Message,
                    })));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                let elems_4, el_19, matchValue, el_16, el_14;
                return unread ? singleton(createElement("div", createObj(ofArray([["style", {
                    flexShrink: 0,
                    alignSelf: "center",
                    opacity: hover ? 1 : 0,
                    transitionProperty: "opacity",
                    transitionDuration: 120 + "ms",
                }], (elems_4 = [(el_19 = Tooltip, createElement(el_19, createObj(ofArray([["content", "Marker som lest"], ["relationship", "label"], (matchValue = tryHead([(el_16 = Button, createElement(el_16, {
                    appearance: "subtle",
                    size: "small",
                    icon: (el_14 = CheckmarkRegular, createElement(el_14, {
                        fontSize: 16,
                    })),
                    onClick: (ev_1) => {
                        ev_1.stopPropagation();
                        updateNotification(new Notification_1(notification.Id, notification.NotificationType, notification.Title, notification.Message, notification.Inserted, notification.ObjectId, true), ctx, setCtx);
                    },
                }))]), (matchValue == null) ? ["children", defaultOf()] : ["children", matchValue])]))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : empty();
            }));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

function renderBucket(now, bucket, items) {
    let elems;
    if (items.length === 0) {
        return defaultOf();
    }
    else {
        return createElement("section", createObj(ofArray([["style", {
            paddingBottom: 6,
        }], (elems = toList(delay(() => {
            let el;
            return append(singleton((el = Caption2Strong, createElement(el, {
                style: {
                    display: "block",
                    padding: ((((((10 + "px ") + 16) + "px ") + 4) + "px ") + 16) + "px",
                    color: tokens.colorNeutralForeground4,
                    textTransform: "uppercase",
                    letterSpacing: "0.6px",
                },
                children: bucketLabel(bucket),
            }))), delay(() => map_1((n) => createElement(NotificationRow, n), items)));
        })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

function EmptyState() {
    let elems, el_2, el, el_4, el_6;
    return createElement("div", createObj(ofArray([["style", {
        padding: ((48 + "px ") + 22) + "px",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 8 + "px ",
    }], (elems = [(el_2 = Avatar, createElement(el_2, {
        shape: "circular",
        size: 56,
        color: "brand",
        icon: (el = CheckmarkCircleRegular, createElement(el, {
            fontSize: 32,
        })),
    })), (el_4 = Body1Strong, createElement(el_4, {
        children: "Alt er lest",
    })), (el_6 = Caption1, createElement(el_6, {
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: "Du har ingen nye varsler akkurat nå.",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

class NotificationTab extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["All", "Unread"];
    }
}

function NotificationTab_$reflection() {
    return union_type("Notification.NotificationTab", [], NotificationTab, () => [[], []]);
}

/**
 * Compact inline notification list for embedding in dashboards/sidebars.
 * Renders the most recent notifications (read + unread, capped at `max`) as
 * a flat stack — no header, no tabs, no popover chrome.
 */
export function NotificationListInline(notificationListInlineInputProps) {
    let elems;
    const max = notificationListInlineInputProps.max;
    const items = truncate(max, sortByDescending((_arg) => _arg.Inserted, useCtx()[0].Notifications, {
        Compare: compare,
    }));
    if (items.length === 0) {
        const el = Caption1;
        return createElement(el, {
            style: {
                display: "block",
                color: tokens.colorNeutralForeground3,
                padding: ((8 + "px ") + 4) + "px",
            },
            children: "Ingen varsler enda",
        });
    }
    else {
        return createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
        }], (elems = ofArray(map((notification) => createElement(NotificationRow, notification), items)), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

function NotificationHeader(notificationHeaderInputProps) {
    let elems_3, elems_2, elems, el, elems_1, el_2, el_4, el_8, el_6;
    const onClose = notificationHeaderInputProps.onClose;
    const unreadCount = notificationHeaderInputProps.unreadCount;
    return createElement("div", createObj(ofArray([["style", {
        padding: ((((((14 + "px ") + 18) + "px ") + 10) + "px ") + 18) + "px",
        display: "flex",
        alignItems: "center",
        gap: 10 + "px ",
        flexShrink: 0,
    }], (elems_3 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 10 + "px ",
        flexGrow: 1,
        minWidth: 0,
    }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
        width: 32,
        height: 32,
        borderRadius: 8,
        backgroundColor: tokens.colorBrandBackground2,
        color: tokens.colorBrandForeground1,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
    }], (elems = [(el = AlertRegular, createElement(el, {
        fontSize: 20,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
        minWidth: 0,
    }], (elems_1 = [(el_2 = Subtitle2, createElement(el_2, {
        children: "Varsler",
    })), (el_4 = Caption1, createElement(el_4, {
        style: {
            display: "block",
            color: tokens.colorNeutralForeground3,
        },
        children: (unreadCount > 0) ? (`${unreadCount} ulest${(unreadCount === 1) ? "" : "e"}`) : "Alt er lest",
    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), (el_8 = Button, createElement(el_8, {
        appearance: "subtle",
        icon: (el_6 = DismissRegular, createElement(el_6, {
            fontSize: 20,
        })),
        onClick: (_arg) => {
            onClose();
        },
    }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function TabsBar(tabsBarInputProps) {
    let elems_5;
    const setCtx = tabsBarInputProps.setCtx;
    const totalCount = tabsBarInputProps.totalCount;
    const unreadCount = tabsBarInputProps.unreadCount;
    const setSelectedTab = tabsBarInputProps.setSelectedTab;
    const selectedTab = tabsBarInputProps.selectedTab;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 10 + "px ",
        padding: ((((((4 + "px ") + 14) + "px ") + 10) + "px ") + 14) + "px",
        borderBottom: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2,
        flexShrink: 0,
    }], (elems_5 = toList(delay(() => {
        let el_8, elems_4, el_2, elems_1, elems, el_6, elems_3, elems_2;
        return append(singleton((el_8 = TabList, createElement(el_8, createObj(ofArray([["selectedValue", toString(selectedTab)], ["appearance", "subtle"], ["size", "small"], ["onTabSelect", (_arg, value_1_2) => {
            if (value_1_2.value === toString(new NotificationTab(1, []))) {
                setSelectedTab(new NotificationTab(1, []));
            }
            else {
                setSelectedTab(new NotificationTab(0, []));
            }
        }], (elems_4 = [(el_2 = Tab, createElement(el_2, createObj(ofArray([["value", toString(new NotificationTab(1, []))], (elems_1 = [createElement("span", createObj(ofArray([["style", {
            display: "inline-flex",
            alignItems: "center",
            gap: 6 + "px ",
        }], (elems = toList(delay(() => append(singleton(createElement("span", {
            children: ["Uleste"],
        })), delay(() => {
            let el;
            return (unreadCount > 0) ? singleton((el = CounterBadge, createElement(el, {
                count: unreadCount,
                size: "small",
                appearance: "ghost",
                color: "brand",
            }))) : empty();
        })))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])))), (el_6 = Tab, createElement(el_6, createObj(ofArray([["value", toString(new NotificationTab(0, []))], (elems_3 = [createElement("span", createObj(ofArray([["style", {
            display: "inline-flex",
            alignItems: "center",
            gap: 6 + "px ",
        }], (elems_2 = toList(delay(() => append(singleton(createElement("span", {
            children: ["Alle"],
        })), delay(() => {
            let el_4;
            return (totalCount > 0) ? singleton((el_4 = CounterBadge, createElement(el_4, {
                count: totalCount,
                size: "small",
                appearance: "ghost",
                color: "informative",
            }))) : empty();
        })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))))), delay(() => append(singleton(createElement("div", {
            style: {
                flexGrow: 1,
            },
        })), delay(() => {
            let el_12, el_10;
            return (unreadCount > 0) ? singleton((el_12 = Button, createElement(el_12, {
                appearance: "subtle",
                size: "small",
                icon: (el_10 = CheckmarkCircleRegular, createElement(el_10, {
                    fontSize: 20,
                })),
                children: "Marker alle som lest",
                onClick: (_arg_1) => {
                    updateAllNotification(setCtx);
                },
            }))) : empty();
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

function NotificationListSection(notificationListSectionInputProps) {
    let elems_2;
    const setAllNotificationsFetched = notificationListSectionInputProps.setAllNotificationsFetched;
    const setCtx = notificationListSectionInputProps.setCtx;
    const setIsFetchingNext = notificationListSectionInputProps.setIsFetchingNext;
    const isFetchingNext = notificationListSectionInputProps.isFetchingNext;
    const allNotificationsFetched = notificationListSectionInputProps.allNotificationsFetched;
    const notifications = notificationListSectionInputProps.notifications;
    const selectedTab = notificationListSectionInputProps.selectedTab;
    const filtered = sortByDescending((_arg) => _arg.Inserted, notifications.filter((n) => {
        if (selectedTab.tag === 0) {
            return true;
        }
        else {
            return !n.Opened;
        }
    }), {
        Compare: compare,
    });
    const now = utcNow();
    const grouped = ofArray_1(Array_groupBy((n_1) => bucketOf(now, n_1.Inserted), filtered, {
        Equals: equals,
        GetHashCode: safeHash,
    }), {
        Compare: compare_1,
    });
    return createElement("div", createObj(ofArray([["style", {
        flexGrow: 1,
        overflowY: "auto",
        padding: ((((((4 + "px ") + 6) + "px ") + 6) + "px ") + 6) + "px",
    }], (elems_2 = toList(delay(() => ((filtered.length === 0) ? singleton(createElement(EmptyState, null)) : append(collect((bucket) => singleton(renderBucket(now, bucket, defaultArg(tryFind(bucket, grouped), []))), bucketOrder), delay(() => {
        let elems_1, el_2;
        return (equals(selectedTab, new NotificationTab(0, [])) && !allNotificationsFetched) ? singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            justifyContent: "center",
            padding: 8,
        }], (elems_1 = [(el_2 = Button, createElement(el_2, createObj(toList(delay(() => append(singleton(["appearance", "subtle"]), delay(() => append(singleton(["size", "small"]), delay(() => {
            let elems, el;
            return append(isFetchingNext ? singleton((elems = [(el = Spinner, createElement(el, {
                size: "extra-tiny",
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])) : singleton(["children", "Hent flere"]), delay(() => singleton(["onClick", (_arg_1) => {
                setIsFetchingNext(true);
                fetchNotificationsWithOffset(notifications.length, (nots) => {
                    setCtx(new ContextMsg(5, [append_1(nots, notifications)]));
                    if (nots.length === 0) {
                        setAllNotificationsFetched(true);
                    }
                }, setIsFetchingNext, setCtx);
            }])));
        })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty();
    }))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function NotificationFooter() {
    let elems_1, el_4, elems, el, el_2;
    const patternInput = useCtx();
    return createElement("div", createObj(ofArray([["style", {
        padding: ((10 + "px ") + 14) + "px",
        borderTop: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 8 + "px ",
        flexShrink: 0,
    }], (elems_1 = [(el_4 = Link, createElement(el_4, createObj(ofArray([["href", RouterModule_encodeParts(ofArray(["bruker", int32ToString(patternInput[0].User.Id)]), 1)], ["appearance", "subtle"], ["style", {
        display: "inline-flex",
        alignItems: "center",
        gap: 4 + "px ",
        textDecoration: "none",
        color: tokens.colorBrandForeground1,
        fontWeight: 600,
    }], (elems = [(el = Caption1, createElement(el, {
        style: {
            color: tokens.colorBrandForeground1,
        },
        children: "Se alle varsler",
    })), (el_2 = ArrowRightRegular, createElement(el_2, {
        fontSize: 16,
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function NotificationComponent(notificationComponentInputProps) {
    let elems;
    const onClose = notificationComponentInputProps.onClose;
    const patternInput = reactApi.useState(new NotificationTab(1, []));
    const selectedTab = patternInput[0];
    const patternInput_1 = reactApi.useState(false);
    const patternInput_2 = useCtx();
    const setCtx = patternInput_2[1];
    const ctx = patternInput_2[0];
    const patternInput_3 = reactApi.useState(false);
    let unreadCount;
    const array_1 = ctx.Notifications.filter((n) => !n.Opened);
    unreadCount = array_1.length;
    const totalCount = ctx.Notifications.length | 0;
    return createElement("div", createObj(ofArray([["style", {
        height: 100 + "%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
    }], (elems = [createElement(NotificationHeader, {
        unreadCount: unreadCount,
        onClose: onClose,
    }), createElement(TabsBar, {
        selectedTab: selectedTab,
        setSelectedTab: patternInput[1],
        unreadCount: unreadCount,
        totalCount: totalCount,
        setCtx: setCtx,
    }), createElement(NotificationListSection, {
        selectedTab: selectedTab,
        notifications: ctx.Notifications,
        allNotificationsFetched: patternInput_3[0],
        isFetchingNext: patternInput_1[0],
        setIsFetchingNext: patternInput_1[1],
        setCtx: setCtx,
        setAllNotificationsFetched: patternInput_3[1],
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function NotificationMenu() {
    let icons_1, value_1_2, value_2_1, icons_3, value_1_3, value_2_2, elems_1, el_4, elems_2, elems_4, el_6, el_8, elems_3, elemsToUse;
    const patternInput = useCtx();
    const patternInput_1 = reactApi.useState(false);
    const setIsOpen = patternInput_1[1];
    const isOpen = patternInput_1[0];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    let unreadCount;
    const array_1 = patternInput[0].Notifications.filter((n) => !n.Opened);
    unreadCount = array_1.length;
    let bellButton;
    const el = Button;
    bellButton = createElement(el, {
        size: "large",
        appearance: "transparent",
        "aria-label": "Varsler",
        icon: (unreadCount > 0) ? ((icons_1 = (new BundleIcons((value_1_2 = AlertBadgeFilled, value_1_2), (value_2_1 = AlertBadgeRegular, value_2_1))), bundleIcon([icons_1.Filled, icons_1.Regular][0], [icons_1.Filled, icons_1.Regular][1])({}))) : ((icons_3 = (new BundleIcons((value_1_3 = AlertFilled, value_1_3), (value_2_2 = AlertRegular, value_2_2))), bundleIcon([icons_3.Filled, icons_3.Regular][0], [icons_3.Filled, icons_3.Regular][1])({}))),
        onClick: (_arg) => {
            setIsOpen(!isOpen);
        },
    });
    const bellWithBadge = createElement("div", createObj(ofArray([["style", {
        position: "relative",
        display: "inline-flex",
    }], (elems_1 = toList(delay(() => append(singleton(bellButton), delay(() => {
        let elems, el_2;
        return (unreadCount > 0) ? singleton(createElement("div", createObj(ofArray([["aria-hidden", true], ["style", {
            position: "absolute",
            top: 4,
            right: 4,
            pointerEvents: "none",
        }], (elems = [(el_2 = CounterBadge, createElement(el_2, {
            count: unreadCount,
            size: "small",
            appearance: "filled",
            color: "danger",
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    if (isMobile) {
        const xs_2 = [bellWithBadge, (el_4 = OverlayDrawer, createElement(el_4, createObj(ofArray([["open", isOpen], ["position", "bottom"], ["modalType", "modal"], ["onOpenChange", (_arg_1, value_1_7) => {
            if (!value_1_7.open) {
                setIsOpen(false);
            }
        }], ["style", {
            height: 85 + "vh",
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
        }], (elems_2 = [createElement(NotificationComponent, {
            onClose: () => {
                setIsOpen(false);
            },
        })], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))];
        return react.createElement(react.Fragment, {}, ...xs_2);
    }
    else {
        const el_10 = Popover;
        return createElement(el_10, createObj(ofArray([["positioning", {
            position: "below",
            align: "end",
        }], ["open", isOpen], ["onOpenChange", (_arg_2, value_1_10) => {
            setIsOpen(value_1_10.open);
        }], (elems_4 = [(el_6 = PopoverTrigger, createElement(el_6, {
            disableButtonEnhancement: true,
            children: bellWithBadge,
        })), (el_8 = PopoverSurface, createElement(el_8, createObj(ofArray([["style", {
            width: 400,
            maxHeight: 75 + "vh",
            padding: 0,
            borderRadius: 12,
            backgroundColor: tokens.colorNeutralBackground1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
        }], (elems_3 = [createElement(NotificationComponent, {
            onClose: () => {
                setIsOpen(false);
            },
        })], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))], (elemsToUse = ((length(elems_4) <= 2) ? elems_4 : take(2, elems_4)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
    }
}

//# sourceMappingURL=Notification.jsx.map
